// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__fcVzZ","gfeWrapper":"CalendarEvent_gfeWrapper__1n0lt"};